import { noop } from "lodash-es";

export async function handleFormikValueChange(
  props: $TSFixMe,
  value: $TSFixMe,
) {
  const { name, handleChange, handleBlur = noop } = props;

  const event = {
    persist: () => false,
    target: {
      value,
      name,
      type: "text",
    },
  };
  // we need to call blur to set touched to true!
  handleBlur(event);
  handleChange(event);
}

function handleCheckboxChange(props: $TSFixMe) {
  const { handleChange, name } = props;
  const value = props.values[name] === true ? false : true; // eslint-disable-line no-unneeded-ternary
  const event = {
    persist: () => false,
    target: {
      value,
      name,
      type: "text",
    },
  };
  handleChange(event);
}

export function handleFormikCheckboxChange(
  props: $TSFixMe,
  isEventPropagate: $TSFixMe,
) {
  // Fix for IE
  // @ts-expect-error TS(2551) FIXME: Property 'documentMode' does not exist on type 'Do... Remove this comment to see the full error message
  if (!isEventPropagate && window.document.documentMode) {
    handleCheckboxChange(props);
  }

  // Normal configuration
  // @ts-expect-error TS(2551) FIXME: Property 'documentMode' does not exist on type 'Do... Remove this comment to see the full error message
  if (!window.document.documentMode) {
    handleCheckboxChange(props);
  }
}
